export default __webpack_public_path__ + "static/media/TirthankarRoy.d7d966c4.jpg";